module.exports = __webpack_public_path__ + "static/media/marseille-5.fa9f36b2.jpg";